import React from 'react';
import PropTypes from 'prop-types';
import { useSearchResultsActions } from '@sitecore-search/react';
import { Pagination } from '@sitecore-search/ui';

const SearchPagination = ({ currentPage, totalPages }) => {
    const { onPageNumberChange } = useSearchResultsActions();
    return (
        <Pagination.Root
            currentPage={currentPage}
            defaultCurrentPage={1}
            totalPages={totalPages}
            onPageChange={v => {
                onPageNumberChange({ page: v });
            }}
            className="sitecore-search-block-pagination"
        >
            <Pagination.PrevPage
                onClick={e => e.preventDefault()}
                className="pagination-nav"
            >
                Prev
            </Pagination.PrevPage>
            <Pagination.Pages className="pagination-pages">
                {pagination => Pagination.paginationLayout(pagination, {
                    boundaryCount: 1,
                    siblingCount: 1
                }).map(({ page, type }) => (
                    type === 'page' ? (
                        <Pagination.Page
                            key={page}
                            aria-label={`Page ${page}`}
                            page={page}
                            onClick={e => e.preventDefault()}
                            className="pagination-item"
                        >
                            {page}
                        </Pagination.Page>
                    ) : (
                        <span key={type} className="pagination-ellipsis">...</span>
                    )
                ))}
            </Pagination.Pages>
            <Pagination.NextPage
                onClick={e => e.preventDefault()}
                className="pagination-nav"
            >
                Next
            </Pagination.NextPage>
        </Pagination.Root>
    );
};

SearchPagination.propTypes = {
    currentPage: PropTypes.number.isRequired,
    totalPages: PropTypes.number.isRequired
};

export default SearchPagination;
